import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M27.65,7.86,22.43,2.69A.64.64,0,0,0,22,2.5H11A2.65,2.65,0,0,0,8.27,5.11v1.5H6.84A2.66,2.66,0,0,0,4.16,9.23V26.89A2.65,2.65,0,0,0,6.84,29.5H21.05a2.65,2.65,0,0,0,2.68-2.61v-1.5h1.43a2.66,2.66,0,0,0,2.68-2.62V8.32A.66.66,0,0,0,27.65,7.86Zm-1.39.45h-2.4A1.75,1.75,0,0,1,22,6.65V4.12ZM22.43,26.89a1.35,1.35,0,0,1-1.38,1.31H6.84a1.35,1.35,0,0,1-1.38-1.31V9.23A1.35,1.35,0,0,1,6.84,7.91H8.27V22.77A2.66,2.66,0,0,0,11,25.39H22.43Zm2.73-2.8H11a1.35,1.35,0,0,1-1.38-1.32V5.11A1.35,1.35,0,0,1,11,3.8h9.78V6.65a3.05,3.05,0,0,0,3.13,3h2.68V22.77A1.35,1.35,0,0,1,25.16,24.09Z' }),
  React.createElement('path', { d: 'M12.25,12.1h5a.65.65,0,0,0,0-1.3h-5a.65.65,0,1,0,0,1.3Z' }),
  React.createElement('path', { d: 'M23.87,15H12.25a.66.66,0,0,0-.66.65.66.66,0,0,0,.66.65H23.87a.65.65,0,0,0,0-1.3Z' }),
  React.createElement('path', { d: 'M23.87,19.1H12.25a.66.66,0,0,0-.66.65.66.66,0,0,0,.66.65H23.87a.65.65,0,1,0,0-1.3Z' })
));